module.exports = __webpack_public_path__ + "img/i-7.67ec6125.svg";